import "./App.css";
import Landing from "./components/landing/landing";
import EnterIdea from "./components/landing/enterIdea";
import Overview from "./components/dashboard/overview";
import PersonaAnalyser from "./components/dashboard/persona-analyser";
import { Route, Routes } from "react-router-dom";
import WorkspacesPage from "./components/landing/allWorkspaces";
import CompetitorAnalysis from "./components/dashboard/competitor-analysis";

function App() {
  return (
    <div className="App font-urbanist">
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/workspaces" element={<WorkspacesPage />} />
        <Route path="/enter-idea" element={<EnterIdea />} />
        <Route path="/overview" element={<Overview />} />
        <Route path="/persona-analyser" element={<PersonaAnalyser />} />
        <Route path="/competitor-analysis" element={<CompetitorAnalysis/>} />
      </Routes>
    </div>
  );
}

export default App;
